var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_384",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29257",
    "data-name": "Group 29257",
    transform: "translate(211 11099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -211, -11099)",
    filter: "url(#Ellipse_384)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384-2",
    "data-name": "Ellipse 384",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_15_",
    "data-name": "svgexport-17 (15)",
    transform: "translate(-189.778 -11081.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50094",
    "data-name": "Path 50094",
    d: "M368.868,368.475h.941V372.4h-.941Z",
    transform: "translate(-346.612 -345.694)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_439",
    "data-name": "Ellipse 439",
    cx: 2.535,
    cy: 2.535,
    rx: 2.535,
    ry: 2.535,
    transform: "translate(20.192 26.116)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_440",
    "data-name": "Ellipse 440",
    cx: 0.792,
    cy: 0.792,
    rx: 0.792,
    ry: 0.792,
    transform: "translate(21.935 27.859)",
    fill: "#524798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50095",
    "data-name": "Path 50095",
    d: "M423.342,406.243h-3.109a.627.627,0,0,1-.567-.359l-.912-1.923h4.589a.627.627,0,0,1,.627.627v1.027a.628.628,0,0,1-.628.627Z",
    transform: "translate(-393.413 -378.986)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50096",
    "data-name": "Path 50096",
    d: "M56.523,24.975l-1.358-2.864a.471.471,0,0,0-.425-.269H52.4v.941h2.045l1.04,2.191ZM35.519,1.8h-.941V1.738a.8.8,0,0,0-.8-.8H31.542V0h2.239a1.74,1.74,0,0,1,1.738,1.738Z",
    transform: "translate(-30.141 0)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50097",
    "data-name": "Path 50097",
    d: "M10.908.376V3.553a.376.376,0,0,1-.376.376H9.256a.376.376,0,0,1-.376-.376V.376A.376.376,0,0,1,9.256,0h1.275a.376.376,0,0,1,.377.377Z",
    transform: "translate(-8.88 0)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50098",
    "data-name": "Path 50098",
    d: "M98.772,233.823H80.638V224.95H96.864a2.535,2.535,0,0,1,2.535,2.535V233.2a.627.627,0,0,1-.627.627Z",
    transform: "translate(-76.202 -211.042)",
    fill: "#df75a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50099",
    "data-name": "Path 50099",
    d: "M90.236,224.95h-9.6v5.5a5.576,5.576,0,0,1,10.015,3.376h4.69A10.273,10.273,0,0,0,90.236,224.95Z",
    transform: "translate(-76.202 -211.042)",
    fill: "#dd5790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50100",
    "data-name": "Path 50100",
    d: "M84.441,40.284h-3.8V28.115h.712a2.535,2.535,0,0,1,2.531,2.39Z",
    transform: "translate(-76.202 -26.377)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50101",
    "data-name": "Path 50101",
    d: "M95.748,30.532a2.535,2.535,0,0,0-2.461-2.389,2.533,2.533,0,0,1,1.194,2.008l.56,10.159h1.267Z",
    transform: "translate(-88.069 -26.403)",
    fill: "#b7c8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50102",
    "data-name": "Path 50102",
    d: "M46.438,256.007h-5.07a.471.471,0,0,1,0-.941h5.07a.471.471,0,0,1,0,.941Zm-6.972-1.9a.471.471,0,0,1-.471-.471v-5.071a.471.471,0,0,1,.941,0v5.071A.47.47,0,0,1,39.466,254.106Zm0,8.873a.471.471,0,0,1-.471-.471v-5.071a.471.471,0,1,1,.941,0v5.071A.47.47,0,0,1,39.466,262.979Zm-1.345-8.317a.469.469,0,0,1-.333-.138L34.2,250.939a.471.471,0,1,1,.666-.666l3.585,3.585a.47.47,0,0,1-.333.8Zm6.275,6.275a.469.469,0,0,1-.333-.138l-3.585-3.585a.471.471,0,1,1,.666-.666l3.585,3.585a.471.471,0,0,1-.333.8Zm-6.831-4.93H32.494a.471.471,0,1,1,0-.941h5.071a.471.471,0,1,1,0,.941Zm-3.029,4.93a.471.471,0,0,1-.333-.8l3.585-3.585a.471.471,0,1,1,.666.666L34.868,260.8A.469.469,0,0,1,34.536,260.937Zm6.275-6.275a.47.47,0,0,1-.333-.8l3.585-3.585a.471.471,0,1,1,.666.666l-3.585,3.585a.469.469,0,0,1-.333.138Z",
    transform: "translate(-30.592 -232.755)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50103",
    "data-name": "Path 50103",
    d: "M17.753,224.95a8.873,8.873,0,1,0,8.873,8.873A8.873,8.873,0,0,0,17.753,224.95Zm0,15.846a6.972,6.972,0,1,1,6.972-6.972A6.972,6.972,0,0,1,17.753,240.8Z",
    transform: "translate(-8.88 -211.042)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50104",
    "data-name": "Path 50104",
    d: "M51.139,254.763a8.888,8.888,0,0,1,1.513,7.818,6.974,6.974,0,0,1-6.14,6.14,8.888,8.888,0,0,1-7.818-1.513,8.873,8.873,0,1,0,12.444-12.444Z",
    transform: "translate(-36.852 -239.012)",
    fill: "#524798"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_441",
    "data-name": "Ellipse 441",
    cx: 1.901,
    cy: 1.901,
    rx: 1.901,
    ry: 1.901,
    transform: "translate(6.972 20.88)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50105",
    "data-name": "Path 50105",
    d: "M126.89,340.444a1.9,1.9,0,0,1-2.515,2.515,1.9,1.9,0,1,0,2.515-2.515Z",
    transform: "translate(-117.234 -319.396)",
    fill: "#b7c8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50106",
    "data-name": "Path 50106",
    d: "M139.992,161.366H129.851v-.761a1.268,1.268,0,0,1,1.268-1.268h7.606a1.268,1.268,0,0,1,1.268,1.268v.761Z",
    transform: "translate(-122.372 -149.487)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50107",
    "data-name": "Path 50107",
    d: "M80.638,184.532H94.963a.471.471,0,0,1,.471.471v2.028h-.941v-1.558H80.638Z",
    transform: "translate(-76.202 -173.123)",
    fill: "#d8e2f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/Wheelchair.a3c18fa77b6744d6e6c1abfd4a137a95.svg";
export { ForwardRef as ReactComponent };